import React, { Dispatch, SetStateAction, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { BasicButton } from '../../widgets/components/UI/BasicButton'
import { useAuth } from '../../auth'
import { createAccessRequest } from '../core/_requests'
import { toast } from 'react-toastify'

export const RequestAccessModal = ({
  headingMessage,
  description,
  showAccessModal,
  setShowAccessModal,
  recordId, action
}: {
  showAccessModal: boolean
  setShowAccessModal: Dispatch<SetStateAction<boolean>>
  headingMessage: string
  description: string
  recordId: string | undefined,
  action: string
}) => {
  const { companyId } = useAuth()
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const requestSubmit = async () => {
    if (!companyId || !recordId) return
    try {
      setLoading(true)
      const {
        data: { success },
      } = await createAccessRequest({ action: action }, companyId, recordId)
      if (success) {
        toast.success('Access request sent successfully')
      }
    }
    catch (e: any) {
      toast.error(e.message)
    } finally {
      setLoading(false)
      setShowAccessModal(false)
    }
  }
  return (
    <Modal
      show={showAccessModal}
      onHide={() => setShowAccessModal(false)}
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <h2>{formatMessage({ id: headingMessage })}</h2>
      </Modal.Header>
      <Modal.Body>
        <p>
          {formatMessage({
            id: description,
          })}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <BasicButton
          height='44px'
          border='none'
          color='#F5F8FA'
          textColor='#7E8299'
          padding='12px 16px'
          onClick={() => {
            setShowAccessModal(false)
          }}
          disabled={loading}
          buttonText='Cancel'
          minWidth={56}
        />

        <BasicButton
          height='44px'
          border='1px solid #4776E6'
          color='#4776E6'
          textColor='white'
          padding='12px 24px'
          buttonText='Request Access'
          minWidth={56}
          disabled={loading}
          onClick={() => requestSubmit()}
        />
      </Modal.Footer>
    </Modal>
  )
}
